import type { EmployeesCriticalWorkMinutes } from '@api/ShiftGeneratorResultService';
import { useEmployeesCriticalWorkMinutesEntry } from '@stores/shiftGeneratorResultStore';
import { useParams } from 'react-router';
import { useMemo } from 'react';

const useEmployeesCriticalWorkMinutes = (): {
    employeeCriticalWorkMinutes:
        | EmployeesCriticalWorkMinutes['elements']
        | undefined;
    departmentId: string | undefined;
    taskId: string | undefined;
    isLoadingEmployeeCriticalWorkMinutes: boolean;
} => {
    const { departmentId, taskId } = useParams<{
        departmentId: string;
        taskId: string;
    }>();

    const {
        response: criticalWorkMinutes,
        isLoading: isLoadingEmployeeCriticalWorkMinutes,
    } = useEmployeesCriticalWorkMinutesEntry(departmentId, taskId);

    const employeeCriticalWorkMinutes = useMemo(
        () => criticalWorkMinutes?.elements,
        [criticalWorkMinutes],
    );

    return {
        employeeCriticalWorkMinutes,
        departmentId,
        taskId,
        isLoadingEmployeeCriticalWorkMinutes,
    };
};

export default useEmployeesCriticalWorkMinutes;
